<div class="wrapper-faq">
    <div class="section-title">
		<div class="row">
			<div class="col">
				<div class="d-flex align-items-center">
					<a routerLink="/dashboard/overview" class="btn btn-back" [attr.aria-label]="'Back' | translate">
						<i class="fi-rr-arrow-alt-left"></i>
					</a>
					<div class="title" [attr.data-parent]="'Dashboard' | translate">{{ "Help Center" | translate }}</div>
				</div>
			</div>
		</div>
  </div>
    <div class="section-main">
        <div class="container mt-4">
            <div class="row">
                <div class="col-xl-8 xl-60 col-lg-7 col-md-7">
                    <div *ngIf="loading" class="text-center">
                        <div class="loading-spinner col-12">
                            <mat-spinner
                              class="mx-auto my-3"
                              [diameter]="50"
                            ></mat-spinner>
                          </div>
                    </div>
                    <div *ngFor="let item of createCategory(); let index=index">
                        <h3 class="title">{{ "{0}" |  translate:[utils.translate(records[index]['category'])]| uppercase }}</h3>
                        <div class="section-cards"  *ngIf="!loading">
                            <div class="card card-white mt-3" *ngFor="let subItem of createQuestionAnswer(records[index]['category']); let subIndex=index">
                                <div (click)="toggleAnswer(index, subIndex)" class="row card-contents">
                                    <div class="w-90">
                                        <p [className]="!answer[index][subIndex] ? 'card-text' : 'card-text-blue'">{{ records[index]['qa'][subIndex][0]  | translate }}</p>
                                    </div>
                                    <div class="w-10">
                                        <i *ngIf="!answer[index][subIndex]" class="fi fi-rr-angle-small-up"></i>
                                        <i *ngIf="answer[index][subIndex]" class="fi fi-rr-angle-small-down"></i>
                                        <!-- <img *ngIf="!answer[index][subIndex]" class="plus-icon" src="../../assets/icon/plus-icon.png" alt="plus">
                                        <img *ngIf="answer[index][subIndex]" class="minus-icon" src="../../assets/icon/minus-icon.png" alt="minus"> -->
                                    </div>
                                    <div [@collapse]="!answer[index][subIndex]" class="section-info">
                                        <p class="card-info">
                                            {{ records[index]['qa'][subIndex][1] | translate }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 xl-40 col-lg-5 col-md-5">
                    <div class="card-knowledge-base mt-4">
                        <div class="knowledge-base-header">
                            <h3 class="title">{{ "Navigation" | translate }}</h3>
                            <i class="fi fi fi-rr-navigation"></i>
                        </div>
                        <div class="knowledge-base-body">
                            <a routerLink='/dashboard/knowledge-base'>
                                <i class="fi fi fi-rr-bulb"></i>
                                {{ "Knowledgebase" | translate }}
                            </a>
                            <!--<a routerLink='/dashboard/e-ticketing-list'>
                                <i class="fi fi fi-rr-notebook"></i>
                                {{ "Feedback" | translate }}
                            </a>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>